"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _cccisdDetectClickLocation = _interopRequireDefault(require("cccisd-detect-click-location"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _Report = _interopRequireDefault(require("./Report"));
var _DownloadText = _interopRequireDefault(require("./DownloadText"));
var _style = _interopRequireDefault(require("./style.css"));
var _table = _interopRequireDefault(require("cccisd-icons/table2"));
var _filePdf = _interopRequireDefault(require("cccisd-icons/file-pdf"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Exports = function Exports(props) {
  var assignment = props.assignment,
    surveyHandles = props.surveyHandles,
    typeFilter = props.typeFilter,
    elementIcons = props.elementIcons,
    downloadCsv = props.downloadCsv;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];
  var clickedOutside = function clickedOutside() {
    setShow(false);
  };
  var renderDropDown = function renderDropDown() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].exportMenu
    }, /*#__PURE__*/_react["default"].createElement("ul", null, /*#__PURE__*/_react["default"].createElement("a", {
      onClick: downloadCsv
    }, /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement(_table["default"], null), " ", /*#__PURE__*/_react["default"].createElement("span", null, "Download CSV"))), /*#__PURE__*/_react["default"].createElement(_DownloadText["default"], {
      type: "SPS",
      assignment: assignment,
      surveyHandles: surveyHandles,
      typeFilter: typeFilter
    }), /*#__PURE__*/_react["default"].createElement(_DownloadText["default"], {
      type: "SAS",
      assignment: assignment,
      surveyHandles: surveyHandles,
      typeFilter: typeFilter
    }), /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
      trigger: /*#__PURE__*/_react["default"].createElement("a", null, /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement(_filePdf["default"], null), " ", /*#__PURE__*/_react["default"].createElement("span", null, "Codebook PDF"))),
      size: "large"
    }, /*#__PURE__*/_react["default"].createElement(_Report["default"], {
      assignment: assignment,
      surveyHandles: surveyHandles,
      typeFilter: typeFilter,
      elementIcons: elementIcons
    }))));
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].exports
  }, /*#__PURE__*/_react["default"].createElement(_cccisdDetectClickLocation["default"], {
    clickedOutside: clickedOutside,
    additionalOutsideTest: function additionalOutsideTest(e) {
      return !(e.path || []).find(function (n) {
        return n.className === 'modal-content';
      });
    }
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn btn-default",
    onClick: function onClick() {
      setShow(!show);
    }
  }, "Exports ", /*#__PURE__*/_react["default"].createElement("span", {
    className: _style["default"].caret
  })), show && renderDropDown()));
};
var _default = Exports;
exports["default"] = _default;